"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_clock__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "c1a06138-5820-4659-ac3f-d2368ed6178e",
    "data-name": "clock-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b14f77e5-0f53-425a-9648-74bd875216a6",
    x1: 89.18,
    y1: 61.86,
    x2: 128.99,
    y2: 101.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "526ba3de-64f7-4a11-a18e-ed2614c31a0a",
    x1: 98.69,
    y1: 52.1,
    x2: 98.81,
    y2: 52.1,
    xlinkHref: "#b14f77e5-0f53-425a-9648-74bd875216a6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7d856012-25af-4ad1-9275-88ef40b306e7",
    x1: 93.06,
    y1: 128.82,
    x2: 181.32,
    y2: 128.82,
    xlinkHref: "#b14f77e5-0f53-425a-9648-74bd875216a6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "7be2593e-35fb-48e1-9274-cd2761de325d",
    x1: 107.02,
    y1: 84.77,
    x2: 168.9,
    y2: 146.65,
    xlinkHref: "#b14f77e5-0f53-425a-9648-74bd875216a6"
  })), /*#__PURE__*/React.createElement("title", null, "clock-hi-dark"), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "bf24dcd3-f05d-4ab2-ab42-ce2db2b5a776",
    "data-name": "<Pfad>",
    x1: 166.03,
    y1: 96,
    x2: 154.5,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "e2269470-5488-4c92-9658-eb44487ada69",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 37,
    x2: 96,
    y2: 25.77,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "2cb2f33d-2d9a-416a-8747-73ad5c2e4fca",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 166.03,
    x2: 96,
    y2: 154.5,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "86d67fc5-2d8c-427c-9baa-cb2f93a933f3",
    "data-name": "<Pfad>",
    x1: 25.97,
    y1: 96,
    x2: 37.5,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("line", {
    id: "a35c13f3-b733-4404-ab23-b72ae442ae70",
    "data-name": "<Pfad>",
    x1: 126.09,
    y1: 43.3,
    x2: 130.67,
    y2: 35.01,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "90699fe4-36b7-4a59-85e8-74480c6e3340",
    "data-name": "<Pfad>",
    x1: 148.77,
    y1: 65.29,
    x2: 156.68,
    y2: 60.67,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "c136bcc1-5d52-4272-acce-cc4752f16658",
    "data-name": "<Pfad>",
    x1: 148.7,
    y1: 126.09,
    x2: 156.99,
    y2: 130.67,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "c5d3e3c5-9a9b-4573-9ef8-02650cff18f2",
    "data-name": "<Pfad>",
    x1: 126.71,
    y1: 148.77,
    x2: 131.33,
    y2: 156.68,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "74ddc0d7-8f53-4fbf-be4a-0095bb118c93",
    "data-name": "<Pfad>",
    x1: 65.91,
    y1: 148.7,
    x2: 61.33,
    y2: 156.99,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "f2397353-7e3b-4117-806d-00c73fcd950c",
    "data-name": "<Pfad>",
    x1: 43.23,
    y1: 126.71,
    x2: 35.32,
    y2: 131.33,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "0a2bfba7-3368-4c39-ac2c-623114368a9f",
    "data-name": "<Pfad>",
    x1: 43.3,
    y1: 65.91,
    x2: 35.01,
    y2: 61.33,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "06cf280f-a7f6-4b36-9978-e6aaaa87c520",
    "data-name": "<Pfad>",
    x1: 65.29,
    y1: 43.23,
    x2: 60.67,
    y2: 35.32,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "e2ba19df-a2b7-4145-aeb4-b551d485db01",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 96,
    x2: 140.5,
    y2: 96,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "7cf26df0-05f3-490c-b28f-62313a8fb5e3",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 96,
    x2: 96,
    y2: 55,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.5,98H96a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4h44.5a4,4,0,0,0,3.86-5A4,4,0,0,1,140.5,98Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96,26A70,70,0,1,1,26,96,70.08,70.08,0,0,1,96,26m0-10a80,80,0,1,0,80,80A80,80,0,0,0,96,16Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,24A70.08,70.08,0,0,0,26,94c0,.34,0,.67,0,1A70,70,0,0,1,166,95c0-.33,0-.66,0-1A70.08,70.08,0,0,0,96,24Z",
    transform: "translate(0 0)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95c0,.33,0,.66,0,1a80,80,0,0,0,160,0c0-.34,0-.67,0-1A80,80,0,0,1,96,174Z",
    transform: "translate(0 0)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.65,92,98.85,52.19A4,4,0,0,1,100,55V92Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#b14f77e5-0f53-425a-9648-74bd875216a6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.81,52.15l-.1-.1h0Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#526ba3de-64f7-4a11-a18e-ed2614c31a0a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,26a70,70,0,1,0,46.55,122.22L93.06,98.73h0A4,4,0,0,0,96,100h44.5a4,4,0,0,0,2.86-6.79h0l20.38,20.38A70,70,0,0,0,96,26Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,128.75l-.06.14Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#7d856012-25af-4ad1-9275-88ef40b306e7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.36,93.21A4,4,0,0,1,140.5,100H96a4,4,0,0,1-2.91-1.27h0l49.49,49.49a70.08,70.08,0,0,0,21.21-34.63L143.38,93.21Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#7be2593e-35fb-48e1-9274-cd2761de325d)"
  }));
}

var _default = ic_clock__dark;
exports.default = _default;